import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import SubmissionForm from "@/components/SubmissionForm";

const PERKS = [
  { title: "Des projets variés", text: "Chaque événement est un nouveau défi. Ici, la routine n'existe pas." },
  { title: "Une équipe soudée", text: "Nous cultivons l'entraide, l'exigence bienveillante et le goût du travail bien fait." },
  { title: "De la responsabilité", text: "Nous confions vite des missions à fort impact à celles et ceux qui s'engagent." },
];
const ROLES = ["Chef·fe de projet événementiel", "Chargé·e de production", "Régisseur·se technique", "Commercial·e B2B", "Stage / Alternance", "Candidature spontanée"];

export default function Rejoignez() {
  return (
    <>
      <Seo title="Rejoignez-nous" description="Rejoignez Désir Events, agence événementielle B2B. Découvrez nos opportunités et postulez en quelques clics." path="/rejoignez-nous" />
      <PageHero eyebrow="Rejoignez-nous" title={<>Créons ensemble<br /><span className="italic text-lime-dim">des moments rares.</span></>} subtitle="Nous recherchons des talents passionnés par l'événementiel et animés par le sens du détail." />

      <section className="mx-auto max-w-[1440px] px-5 py-16 md:px-10 md:py-24">
        <div className="grid gap-4 md:grid-cols-3">
          {PERKS.map((p, i) => (
            <Reveal key={p.title} delay={i}>
              <div className="h-full rounded-2xl border border-ink/10 bg-mist p-8">
                <span className="font-serif text-3xl text-lime-dim">0{i + 1}</span>
                <h3 className="mt-4 font-serif text-2xl text-ink">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink/55">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 grid gap-16 md:grid-cols-12">
          <div className="md:col-span-4">
            <Reveal><p className="font-serif text-3xl leading-snug text-ink">Envoyez-nous votre candidature. Même sans offre ouverte, nous étudions chaque profil avec attention.</p></Reveal>
          </div>
          <div className="md:col-span-7 md:col-start-6">
            <div className="rounded-2xl border border-ink/10 bg-mist p-8 md:p-10">
              <SubmissionForm
                type="rejoindre"
                testid="join-form"
                submitLabel="Envoyer ma candidature"
                fields={[
                  { name: "name", label: "Nom complet", required: true, placeholder: "Jean Dupont" },
                  { name: "email", label: "Email", type: "email", required: true, placeholder: "jean@email.com" },
                  { name: "phone", label: "Téléphone", placeholder: "06 12 34 56 78" },
                  { name: "role", label: "Poste visé", type: "select", required: true, options: ROLES },
                  { name: "message", label: "Message & lien vers votre CV / portfolio", type: "textarea", full: true, required: true, placeholder: "Présentez-vous et partagez un lien vers votre CV ou LinkedIn…" },
                ]}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
